import React from 'react'
import { Flex } from 'antd'
import { TabsBadge } from '@/shared/ui/components/Badge'
import { TASK_TABS, TaskStatusType } from '@/pages/tasks/ui/lib/taskTypes'
import { FilterTabs } from '../../styled'

export interface TaskCounts {
  all: number
  processing: number
  completed: number
  suspended: number
  failed: number
  deleted: number
}

export interface TaskFilterTabsProps {
  activeFilter: TaskStatusType
  taskCounts: TaskCounts
  onChange: (filter: TaskStatusType) => void
}

export const TaskFilterTabs: React.FC<TaskFilterTabsProps> = ({
  activeFilter,
  taskCounts,
  onChange,
}) => {
  const tabConfigs = [
    { key: 'all' as const, label: 'Все', count: taskCounts.all },
    {
      key: 'processing' as const,
      label: 'В процессе',
      count: taskCounts.processing,
    },
    { key: 'failed' as const, label: 'Ошибка', count: taskCounts.failed },
    {
      key: 'completed' as const,
      label: 'Завершенные',
      count: taskCounts.completed,
    },
    {
      key: 'suspended' as const,
      label: 'В ожидании',
      count: taskCounts.suspended,
    },
    { key: 'deleted' as const, label: 'Удаленные', count: taskCounts.deleted },
  ]

  const filteredTabs = tabConfigs.filter(
    ({ key, count }) => key === TASK_TABS.ALL || count > 0
  )

  const tabItems = filteredTabs.map(({ key, label, count }) => ({
    key,
    label: (
      <Flex gap={8} align="center">
        {label} <TabsBadge size="small" count={count} overflowCount={9999} />
      </Flex>
    ),
  }))

  return (
    <FilterTabs
      activeKey={activeFilter}
      onChange={(key) => onChange(key as TaskStatusType)}
      type="card"
      size="middle"
      items={tabItems}
    />
  )
}
